import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

interface ColorBlockProps {
  readonly backgroundColor: string;
  readonly color?: TypographyProps['color'];
  readonly className?: string;
  readonly tx: MessageKey;
}

const ColorBlock = ({
  backgroundColor,
  color = null,
  className,
  tx,
}: ColorBlockProps) => {
  return (
    <Typography
      Element="li"
      variant="body-small"
      color={color}
      className={cx('flex items-end p-4 pt-8', className)}
      style={{ backgroundColor }}
    >
      <RichText messageKey={tx} />
    </Typography>
  );
};

export default ColorBlock;
